// ---------------------------------------------------------------------------
// pwaInstall (G-13) — Plattform-Erkennung fuer den iOS-Installations-Hinweis
// ---------------------------------------------------------------------------
// iOS erlaubt Web-Push NUR fuer eine ueber Safari „Zum Home-Bildschirm"
// installierte PWA (ab iOS 16.4). Android/Desktop pushen direkt im Browser.
// Deshalb blenden wir auf iPhone-Safari (nicht bereits installiert) einen
// Hinweis ein. Die reine `shouldShowIosInstallBanner`-Funktion ist ohne
// navigator testbar; die Detektoren kapseln den Browser-Zugriff SSR-/Test-sicher.

export function isStandalonePwa(): boolean {
  if (typeof window === "undefined") return false;
  const displayMode =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(display-mode: standalone)").matches;
  // iOS-spezifisches Legacy-Flag (kein display-mode-Support in aelterem Safari).
  const iosStandalone =
    (window.navigator as Navigator & { standalone?: boolean }).standalone ===
    true;
  return displayMode || iosStandalone;
}

export function isIosDevice(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // iPadOS 13+ meldet sich als „MacIntel" mit Touch — als iOS behandeln.
  return navigator.platform === "MacIntel" && (navigator.maxTouchPoints ?? 0) > 1;
}

export function isIosSafari(): boolean {
  if (!isIosDevice()) return false;
  const ua = navigator.userAgent;
  // Andere iOS-Browser (Chrome/Firefox/Edge/Opera) koennen keine PWA mit Push
  // installieren — nur Safari. Deren UA-Kennungen ausschliessen.
  const otherBrowser = /CriOS|FxiOS|EdgiOS|OPiOS|GSA/i.test(ua);
  return /Safari/i.test(ua) && !otherBrowser;
}

/**
 * Reine Entscheidungsfunktion (testbar): Banner zeigen, wenn iPhone-Safari,
 * noch NICHT installiert und nicht bereits weggeklickt.
 */
export function shouldShowIosInstallBanner(state: {
  iosSafari: boolean;
  standalone: boolean;
  dismissed: boolean;
}): boolean {
  return state.iosSafari && !state.standalone && !state.dismissed;
}
